export const defaultFontMap = {
    "title": "chapterTitle",
    "subtitle": "chapterTitle",
    "author": "chapterTitle",
    "publisher": "chapterNo"
};